import Swiper from "swiper/bundle";

export default new class WhereToBuy {
    constructor() {
        this.whereToBuy = 'where-to-buy__carousel';
        this.handler();


        this.navigation = {
            nextEl: '.where-to-buy-next',
            prevEl: '.where-to-buy-prev'
        };
    }

    handler() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init(){
        const { navigation } = this;

        this.whereToBuyCarousel = new Swiper(`.${this.whereToBuy}`, {
            slidesPerView: 2,
            watchOverflow: true,
            autoplay: true,
            speed: 2000,
            spaceBetween: 16,
            navigation,
            breakpoints: {
                768: {
                    slidesPerView: 4
                },
                1200: {
                    slidesPerView: 4
                },
            }
        });
    }

}();
